import { render, staticRenderFns } from "./Subventionsliste.vue?vue&type=template&id=3a1aea1b"
import script from "./Subventionsliste.vue?vue&type=script&lang=js"
export * from "./Subventionsliste.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports